import router from "@/router";
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import type { Persistor } from "redux-persist";
import { useDispatch, useSelector } from "react-redux";
import { updateUser, type UserSliceState } from "@/store/reducers/userSlice";
import { AppThemeProvider } from "@/theme";

interface ICustomPersistGateProps {
  persistor: Persistor;
}

const CustomPersistGate = ({ persistor }: ICustomPersistGateProps) => {
  const [renderChildren, setRenderChildren] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state: { user: UserSliceState }) => state.user);
  if (!user.updated) {
    dispatch(updateUser());
  }

  const handlePersistorState = () => {
    const { bootstrapped } = persistor.getState();
    if (bootstrapped) {
      setRenderChildren(true);
    }
  }
  useEffect(() => {
    persistor.subscribe(handlePersistorState);
    handlePersistorState();
  }, [persistor]);

  return renderChildren ? (
    <AppThemeProvider>
      <RouterProvider router={router} />
    </AppThemeProvider>
  ) : null;
};

export default CustomPersistGate;
